import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnimationOptions } from 'ngx-lottie';
import { Currency } from 'src/app/models/Lookup';
import { CheckOutResult } from '../CheckOut.models';
import { PlaceOrderService } from 'src/app/features/place-order/services/placeOrder.service';

export interface DialogData {
  type: string // cash, tip, done, doneClient
  currency: Currency
  amount: number
  checkOutResult: CheckOutResult
}

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html'
})
export class PaymentConfirmationComponent implements OnInit {
  loading = false;
  options: AnimationOptions = {
    path: '/assets/js/done-animation.json',
    loop: false,
  };

  printLoading = false;

  constructor(
    private dialogRef: MatDialogRef<PaymentConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private service: PlaceOrderService
  ) { }

  ngOnInit(): void { }

  close(accept: any = false) {
    this.dialogRef.close({accept, checkOutResult: this.data.checkOutResult})
  }

  callPrinting(kitchenId: number) {
    this.loading = true;
    let data: any = {
      kitchenId: kitchenId,
      orderId: this.data.checkOutResult.orderId,
      kdsBonType: 'Add'
    }
    let isApp = false;
    if (localStorage.getItem('deviceId')) {
      isApp = true;
      data.deviceId = localStorage.getItem('deviceId');
      data.deviceType= localStorage.getItem('deviceType');
    }
    this.service.ResPrintOrderBon(data).subscribe((data: any) => {
      this.loading = false;
      if (!isApp) {
        setTimeout(() => { this.print(data.htmlContent); }, 500);
      }
    }, err => {
      console.log(err);
    })
  }

  print(html: string): void {
    const mywindow: any = window.open('', 'PRINT', 'height=600,width=700');
    mywindow.document.write(html);

    mywindow.document.close();
    mywindow.focus();

    mywindow.onload = () => {
      mywindow.print();
    };
  }
}
